import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32a0605b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pagination-group__btn"
}
const _hoisted_2 = {
  key: 1,
  class: "pagination-group__inputBox"
}

import { computed, onMounted, ref, Ref, watch } from 'vue';
import { useAppStore } from '@/store/modules/app';
import { StylesType } from '@/types';
import LoadingPaginationGroup from '@/components/UI/BasePaginationGroup/LoadingPaginationGroup.vue';
import { useElementVisibility } from '@vueuse/core';

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'BasePaginationGroup',
  props: /*#__PURE__*/_mergeModels({
    values: {},
    totalVisible: { default: 3 },
    style: { default: 'simple' },
    minForVisible: { default: 5 },
    maxForVisible: { default: 40 },
    stepForVisible: { default: 5 },
    inputStyles: { default: () => ({ border: 'none' }) },
    showBtn: { type: Boolean, default: true },
    itemCountOnPage: { default: 5 },
    isLoading: { type: Boolean },
    isMoreLoading: { type: Boolean },
    objectCount: {},
    customPage: {},
    autoAddMobile: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(['changePageAndPageSize'], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const model = _useModel<T[]>(__props, "modelValue");

const props = __props;

const emit = __emit;

const autoMobilePagination = ref<HTMLInputElement>();
const isVisibleMobilePagination = useElementVisibility(autoMobilePagination);

const windowWidth = computed((): number => {
  return useAppStore().window;
});
const sortItems = computed(() => {
  let items = [];
  let max = Math.ceil(props.maxForVisible / props.stepForVisible) * props.stepForVisible;

  for (let i = props.minForVisible; i <= max; i = i + props.stepForVisible) {
    items.push({ id: i, name: `${i}` });
  }

  return items;
});
const itemCountOnPage: Ref<number> = ref(props.itemCountOnPage);
const page = ref(1);
const showMoreCount: Ref<number> = ref(0);
const countValues = computed(() => {
  return props.objectCount ? props.objectCount : props.values.length;
});
const paginationLength = computed(() => {
  return Math.ceil(countValues.value / itemCountOnPage.value);
});
const changePage = (pageNumber: number) => {
  page.value = pageNumber;
  emit('changePageAndPageSize', { page: pageNumber, pageSize: +itemCountOnPage.value });
  showMoreCount.value = 0;
  updateValues();
};
const changeItemCountOnPage = (count: number) => {
  if (paginationLength.value < page.value) {
    page.value = countValues.value <= 0 ? 1 : Math.ceil(countValues.value / count);
  }
  itemCountOnPage.value = count;

  emit('changePageAndPageSize', { page: page.value, pageSize: count });
  updateValues();
};

const showMoreClick = () => {
  showMoreCount.value = showMoreCount.value + 1;
  page.value = page.value + 1;
  emit('changePageAndPageSize', {
    page: page.value,
    pageSize: +itemCountOnPage.value,
    showMore: true,
  });
  updateValues();
};

const updateValues = () => {
  model.value = props.values.slice(
    (page.value - 1 - showMoreCount.value) * itemCountOnPage.value,
    itemCountOnPage.value * page.value,
  );
};

onMounted(() => {
  updateValues();
  if (props.customPage) {
    page.value = props.customPage;
  }
});
watch(
  () => props.values,
  () => {
    updateValues();
  },
  {
    deep: true,
  },
);

watch(
  () => props.customPage,
  newValue => {
    if (newValue) {
      page.value = newValue;
    }
  },
);

watch(
  () => isVisibleMobilePagination.value,
  () => {
    if (
      isVisibleMobilePagination.value &&
      !props.isMoreLoading &&
      page.value < paginationLength.value
    ) {
      showMoreClick();
    }
  },
);

return (_ctx: any,_cache: any) => {
  const _component_base_pagination = _resolveComponent("base-pagination")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_select_input = _resolveComponent("base-select-input")!
  const _component_base_spinner = _resolveComponent("base-spinner")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isLoading && !_ctx.autoAddMobile)
      ? (_openBlock(), _createBlock(LoadingPaginationGroup, {
          key: 0,
          showBtn: _ctx.showBtn
        }, null, 8, ["showBtn"]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([{ withoutBtn: !_ctx.showBtn, 'none-Mobile': _ctx.autoAddMobile }, "pagination-group"])
        }, [
          _createVNode(_component_base_pagination, {
            length: paginationLength.value,
            modelValue: page.value,
            showFirstLast: windowWidth.value > 960,
            style: _normalizeStyle(_ctx.style),
            totalVisible: _ctx.totalVisible,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (changePage($event)))
          }, null, 8, ["length", "modelValue", "showFirstLast", "style", "totalVisible"]),
          (_ctx.showBtn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.isMoreLoading || page.value < paginationLength.value)
                  ? (_openBlock(), _createBlock(_component_base_button, {
                      key: 0,
                      loading: _ctx.isMoreLoading,
                      height: "36",
                      text: "Показать еще",
                      width: "165",
                      onClick: showMoreClick
                    }, null, 8, ["loading"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (sortItems.value && sortItems.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createTextVNode(" Показывать по: "),
                _createVNode(_component_base_select_input, {
                  modelValue: itemCountOnPage.value,
                  "onUpdate:modelValue": [
                    _cache[1] || (_cache[1] = ($event: any) => ((itemCountOnPage).value = $event)),
                    _cache[2] || (_cache[2] = ($event: any) => (changeItemCountOnPage(+$event)))
                  ],
                  options: sortItems.value,
                  "show-search": false,
                  class: "pagination-group__inputBox-input",
                  type: "text"
                }, null, 8, ["modelValue", "options"])
              ]))
            : _createCommentVNode("", true)
        ], 2)),
    (_ctx.autoAddMobile)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          ref_key: "autoMobilePagination",
          ref: autoMobilePagination,
          class: "center pagination-group__auto-mobile"
        }, [
          (_ctx.isMoreLoading)
            ? (_openBlock(), _createBlock(_component_base_spinner, {
                key: 0,
                size: 50,
                color: "#009D3E"
              }))
            : _createCommentVNode("", true)
        ], 512))
      : _createCommentVNode("", true)
  ]))
}
}

})